<p-datepicker
  [readonlyInput]="true"
  timeFormat="HH:mm"
  [(ngModel)]="dateAsString"
  (ngModelChange)="modelChange()"
  (onSelect)="dateSelected($event)"
></p-datepicker>
